import React from 'react';
import type { ColorScheme } from '../types/theme';
type ColorSchemeBarProps = {
  value: ColorScheme;
  onChange: (scheme: ColorScheme) => void;
};
const schemes: {
  value: ColorScheme;
  label: string;
  swatches: string[];
}[] = [{
  value: 'plum',
  label: 'Plum',
  swatches: ['#4A1D4F', '#1F1322', '#F6F4EF']
}, {
  value: 'maroon',
  label: 'Maroon',
  swatches: ['#7A1826', '#282A2E', '#EBECEE']
}];
export function ColorSchemeBar({
  value,
  onChange
}: ColorSchemeBarProps) {
  return <div className="bg-ink text-white" data-id="element-47" data-mp="193oglw0dg3ss">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-4 px-6 py-2 sm:justify-end lg:px-8" data-id="element-48" data-mp="192n73vz07pd6">
        <span id="color-scheme-label" className="hidden text-xs font-medium text-white/65 sm:inline" data-id="element-49" data-mp="1e3swpkxdawih">
          Color scheme
        </span>
        <div role="radiogroup" aria-labelledby="color-scheme-label" className="flex gap-1 rounded-md bg-white/10 p-0.5" data-id="element-50" data-mp="3funxkr6fllw2">
          {schemes.map(scheme => {
          const active = scheme.value === value;
          return <button key={scheme.value} type="button" role="radio" aria-checked={active} onClick={() => onChange(scheme.value)} className={`flex items-center gap-2 whitespace-nowrap rounded px-2.5 py-1 text-xs font-semibold transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white ${active ? 'bg-surface text-ink' : 'text-white/75 hover:text-white'}`} data-id="element-51" data-mp="3o80w5li8qcnb">
                <span className="flex" aria-hidden="true" data-id="element-52" data-mp="12jcdzw63sfw">
                  {scheme.swatches.map((color, i) => <span key={color} className={`h-3 w-3 rounded-full ring-1 ring-black/15 ${i > 0 ? '-ml-1' : ''}`} style={{
                backgroundColor: color
              }} data-id="element-53" data-mp="3t6ltnd63yi82" data-mpi={i} />)}
                </span>
                {scheme.label}
              </button>;
        })}
        </div>
      </div>
    </div>;
}